import React from 'react';

const NotFound = () => {
    return ( 
        <h1>404 - page not found</h1>
     );
}
 
export default NotFound;